import { PrimaryButton } from '@systemeio/ui'
import { EmailPreviewModal } from 'modules/mailing/email-statistics/components/email-preview-modal'
import React, { useState } from 'react'
import { EmailInterface } from 'shared/components/dashboard-mail-editor/types/email-interface'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface EmailPreviewProps extends Partial<HTMLDivElement> {
  email?: EmailInterface
}

export const EmailPreview = ({ email, className }: EmailPreviewProps) => {
  const { t } = useLocoTranslation()

  const [isModalOpened, setIsModalOpened] = useState<boolean>(false)

  return (
    <div className={className}>
      <PrimaryButton isFetching={!email} onClick={() => setIsModalOpened(true)}>
        <span>{t('dashboard.email_statistics.preview_email_button_label')}</span>
      </PrimaryButton>
      {email && (
        <EmailPreviewModal
          preview={email.useNewEditor ? email.html ?? '' : email.body ?? ''}
          subject={email.subject}
          opened={isModalOpened}
          onClose={() => setIsModalOpened(false)}
        />
      )}
    </div>
  )
}
